export default __webpack_public_path__ + "static/media/0230.06f90ea2.jpg";